import { NavLink, useLocation } from "react-router-dom";
import { LucideIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

type Props = {
  path: string;
  section: string;
  icon: LucideIcon;
  onClick?: () => void;
};

const NavigationSection = ({ path, section, icon: Icon, onClick }: Props): JSX.Element => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(path);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <NavLink
          to={path}
          onClick={onClick}
          className={cn(
            "flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-200",
            isActive
              ? "bg-palomma-primary/10 hover:bg-palomma-primary/20"
              : "hover:bg-gray-100"
          )}
        >
          <Icon
            className={cn(
              "w-5 h-5",
              isActive ? "text-palomma-primary" : "text-gray-800"
            )}
            strokeWidth={2}
          />
        </NavLink>
      </TooltipTrigger>
      <TooltipContent side="right">
        <p>{section}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default NavigationSection;
